class ReturnedCommentsController {
    constructor() {
        this.showComments = false;
    }

    $onInit() {
        this.showComments = (this.status.match("Amending|PendingAssessment") && this.returnedComments.length) ? true : false;
        this.sectionTitle = this.status === "Amending" ? "Assessor" : "ISU";
    }
}

export default {
    controller: ReturnedCommentsController,
    bindings: {
        status:'@',
        returnedComments:'@'
    },
    templateUrl: `app/components/returned-comments/returned-comments.html`
};


// WEBPACK FOOTER //
// ./app/components/returned-comments/returned-comments.component.js